import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoggedInOnInit } from '../../LoggedInOnInit';
import { UserService } from '../../services/proctor-services/user.service';
import { RecordingsService } from '../../services/proctor-services/recordings.service';
import { ProcteeService } from 'src/app/services/proctor-services/proctee.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ProctorService } from 'src/app/services/proctor.service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { ca, ro } from 'date-fns/locale';

var $: any;
@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})

export class VideosComponent extends LoggedInOnInit implements AfterViewInit {
  examid: string = '';
  candidateno: string = '';
  primaryViewRecordings: any[] = [];
  secondViewRecordings: any[] = [];
  flagtime: any;
  candidateNos: string[] = [];
  loadingCandidateVideoList: boolean = false;
  isCandidateSelected = false;
  displaySelectedCandidate = false;
  passportPhotoUrl: string;
  loadingVideos: boolean;
  @ViewChild('primaryViewVideo') primaryViewVideo: ElementRef<HTMLVideoElement>;
  @ViewChild('secondViewVideo') secondViewVideo: ElementRef<HTMLVideoElement>;
  primaryViewVideoStartAt: number;
  secondViewVideoStartAt: number;
  targetvideotime: number;
  primaryViewVideoUrl: any;
  secondViewVideoUrl: any;
  primaryViewVideoRecordingTime: number;
  secondaryViewVideoRecordingTime: number;
  _synchronizeVideos: boolean = true;
  //@ViewChild('synchronizedSeeker') synchronizedSeeker: ElementRef<HTMLInputElement>;
  settingVideoTime: boolean;
  primaryVideoSeekedTimeout: any;
  secondViewVideoSeekedTimeout: any;
  // suspendSecondViewSyncCount: number = 0;
  // suspendPrimaryViewSyncCount: number = 0;
  loadingSecondViewVideo: boolean;
  loadingPrimaryViewVideo: boolean;
  //mouseDown: boolean;
  //primaryViewVideoSeeking: boolean;

  constructor(private recordingservice: RecordingsService, 
              private activatedroute: ActivatedRoute, 
              private router: Router, 
              private userservice: UserService, 
              private procteeService: ProcteeService, 
              private examService: ExamService,
              private examSch: ExamScheduleService, 
              private auth: AuthService,
              private toastr: ToastrService) {
    super(router, userservice, activatedroute);
    this.examid = this.activatedroute.snapshot.queryParams.examid ?? '';
    this.candidateno = this.activatedroute.snapshot.queryParams.candidateno ?? '';
    // this.targetvideotime = this.activatedroute.snapshot.queryParams.time ?? 0;
    // this.targetvideotimestartat = this.activatedroute.snapshot.queryParams.delay ?? 0;
  }


  async ngOnInit() {
    const ret = super.ngOnInit();

    this.activatedroute.queryParams.subscribe(async (routeParams) => {
      this.examid = routeParams.examid ?? '';
      this.candidateno = routeParams.candidateno ?? '';
      this.flagtime = routeParams.flagtime ?? 0;
    });

    if (!this.examid) {
      this.examid = (this.examService.selectedExamIds && this.examService.selectedExamIds.length > 0) ? this.examService.selectedExamIds[0].toString() : '';
    }
    if (!this.candidateno) {
      this.candidateno = (this.examSch.selectedSchedules && this.examSch.selectedSchedules.length > 0 && this.examSch.selectedSchedules[0]) ? this.examSch.selectedSchedules?.[0]?.examNo : '';
    }
    if (this.candidateno) {
      this.displaySelectedCandidate = true; 
    }

    

    return ret;
  }

  get synchronizeVideos(){
    return this._synchronizeVideos && this.primaryViewRecordings?.length > 0 && this.secondViewRecordings?.length > 0;
  }

  async ngAfterViewInit(): Promise<void> {
    const _primaryViewVideo: HTMLVideoElement = this.primaryViewVideo.nativeElement;
    
    const _secondaryViewVideo: HTMLVideoElement = this.secondViewVideo.nativeElement;

    // _primaryViewVideo.onloadedmetadata = async () => {  
    //   //console.log('duration: ' + _primaryViewVideo.duration);
    //   const startAt = this.primaryViewVideoStartAt;
    //   this.primaryViewVideoStartAt = undefined;
    //   if(startAt){
    //     await this.seekVideoToTime(_primaryViewVideo, startAt);
    //   }
    // };

    _primaryViewVideo.addEventListener('play', async (evt: Event) => {
      if(this.synchronizeVideos){
        //await this.seekVideoToTime(_secondaryViewVideo, this.secondViewVideoStartAt);
        _secondaryViewVideo.play();
      }
    });

    _secondaryViewVideo.addEventListener('play', async (evt: Event) => {
      if(this.synchronizeVideos){
        _primaryViewVideo.play();
      }
    });

    _primaryViewVideo.addEventListener('pause', () => {
      if(this.synchronizeVideos && !_secondaryViewVideo.paused){
        _secondaryViewVideo.pause();
      }
    });

    _secondaryViewVideo.addEventListener('pause', () => {
      if(this.synchronizeVideos && !_primaryViewVideo.paused){
        _primaryViewVideo.pause();
      }
    });

    // _secondaryViewVideo.onloadedmetadata = async () => {  
    //   //console.log('duration: ' + _secondaryViewVideo.duration);
    //   const startAt = this.secondViewVideoStartAt;
    //   this.secondViewVideoStartAt = undefined;
    //   if(startAt){
    //     await this.seekVideoToTime(_secondaryViewVideo, startAt);
    //   }
    // };

    //had to comment this out because the event keeps firing as long as the user is moving the seeking control, not only after the user is done
    //this causes too many requests to be fired, and degrades the UI TREMENDOUSLY

    const _primaryViewVideoSeekedHandler = async () => {
      //while the user is seeking, we don't want to run this code often. so we use timeouts to make sure it can't run more than twice a second
      if(this.synchronizeVideos && _primaryViewVideo.currentTime != Infinity){
        if(this.loadingPrimaryViewVideo){
          return;
        }
        if(this.primaryVideoSeekedTimeout){
          clearTimeout(this.primaryVideoSeekedTimeout);
        }
        //this.synchronizingSecondViewVideo = true;
        this.primaryVideoSeekedTimeout = setTimeout(async () => {
          // let suspend = this.suspendPrimaryViewSyncCount;
          // if(suspend > 0){
          //   suspend--;
          //   this.suspendPrimaryViewSyncCount = suspend;
          //   return;
          // }
          const playedTime = Math.round(_primaryViewVideo.currentTime * 1000);
          const secondViewRecordingInfoAtTime: any = await this.recordingservice.getRecordingInfoAtTime(this.examid, this.candidateno, this.primaryViewVideoRecordingTime + playedTime, true);
          if(secondViewRecordingInfoAtTime){
            this.secondViewVideoStartAt = secondViewRecordingInfoAtTime.startat;
            
            try{
              // let _suspend = this.suspendSecondViewSyncCount;
              // _suspend++;
              // this.suspendSecondViewSyncCount = _suspend;
              await this.loadExamVideo(secondViewRecordingInfoAtTime.recordingtime, true, !_primaryViewVideo.paused, false, false);
            }
            finally{
              //this.synchronizingSecondViewVideo = false;
            }
          }
        }, 500);
      }
      else{
        //this.synchronizingPrimaryViewVideo = false;
      }
    }

    const _secondaryViewVideoSeekedHandler = async () => {
      //while the user is seeking, we don't want to run this code often. so we use timeouts to make sure it can't run more than twice a second
      //console.log('secondary view seeked'); return;
      if(this.synchronizeVideos && _secondaryViewVideo.currentTime != Infinity){
        if(this.loadingSecondViewVideo){
          return;
        }
        if(this.secondViewVideoSeekedTimeout){
          clearTimeout(this.secondViewVideoSeekedTimeout);
        }
        //this.synchronizingPrimaryViewVideo = true;
        this.secondViewVideoSeekedTimeout = setTimeout(async () => {
          // let suspend = this.suspendSecondViewSyncCount;
          // if(suspend > 0){
          //   suspend--;
          //   this.suspendSecondViewSyncCount = suspend;
          //   return;
          // }
          const playedTime = Math.round(_secondaryViewVideo.currentTime * 1000);
          const primaryViewRecordingInfoAtTime: any = await this.recordingservice.getRecordingInfoAtTime(this.examid, this.candidateno, this.secondaryViewVideoRecordingTime + playedTime, false);
          if(primaryViewRecordingInfoAtTime){
            this.primaryViewVideoStartAt = primaryViewRecordingInfoAtTime.startat;
            
            try{
              // let _suspend = this.suspendPrimaryViewSyncCount;
              // _suspend++;
              // this.suspendPrimaryViewSyncCount = _suspend;
              await this.loadExamVideo(primaryViewRecordingInfoAtTime.recordingtime, false, !_secondaryViewVideo.paused, false, false);
            }
            finally{
              //this.synchronizingPrimaryViewVideo = false;
            }
          }
        }, 500);
      }
      else{
        //this.synchronizingSecondViewVideo = false;
      }
    }

    _primaryViewVideo.addEventListener('seeked', _primaryViewVideoSeekedHandler);

    _secondaryViewVideo.addEventListener('seeked', _secondaryViewVideoSeekedHandler);

    // _primaryViewVideo.addEventListener('timeupdate', (evt: Event) => {
    //   if(this.synchronizeVideos){
    //     //this.synchronizedSeeker.nativeElement.value = _primaryViewVideo.currentTime.toString();
    //     this.synchronizedSeeker.nativeElement.setAttribute('value', Math.round(_primaryViewVideo.currentTime).toString());
    //   }
    //   //
    // });

    this.loadCandidates();
    if(this.examid && this.candidateno){
      await this.loadCandidateData(this.examid, this.candidateno);

      // if(this.targetvideotime && this.primaryViewVideoStartAt){
      //   await this.loadExamVideo(this.targetvideotime, false, true, true);
      // }
    }

    // _primaryViewVideo.addEventListener('mousedown', () => {
    //   this.mouseDown = true;
    //   console.log('mouse down');
    // });

    // _primaryViewVideo.addEventListener('mouseup', () => {
    //   this.mouseDown = false;
    //   console.log('mouse up');
    // });

    // _primaryViewVideo.addEventListener('mouseleave', () => {
    //   this.mouseDown = false;
    //   console.log('mouse leave');
    // })
  }

  private seekVideoToTime(video: HTMLVideoElement, startAt: number): Promise<void> {
    const p = new Promise<void>((resolve, reject) => {
      console.trace('started seeking: ', {secondView: video == this.secondViewVideo.nativeElement});
      const _temporarySeekedHandler = () => {
        video.removeEventListener('seeked', _temporarySeekedHandler);
        console.trace('finished seeking: ', {secondView: video == this.secondViewVideo.nativeElement});
        resolve();
      };
      video.addEventListener('seeked', _temporarySeekedHandler);  
    });
    
    this.settingVideoTime = true;
    if (video.duration === Infinity) {
      // set it to bigger than the actual duration
      const _timeUpdateHandler = () => {
        video.removeEventListener('timeupdate', _timeUpdateHandler);

        console.log(' after workaround: ' + video.duration);
        if (startAt > 0) {
          video.currentTime = video.duration > startAt ? startAt : 0;
        }
        else {
          video.currentTime = 0;
        }
        console.log(' after workaround current time is: ' + video.currentTime);
        this.settingVideoTime = false;
      };

      video.currentTime = 1e101;
      video.addEventListener('timeupdate', _timeUpdateHandler);
    }
    else {
      if (startAt > 0) {
        const newTime = video.duration > startAt ? startAt : 0;
        //console.log(`setting new time to ${newTime}`);
        video.currentTime = newTime;
        //console.log(`new time is ${video.currentTime}`);
      }
      this.settingVideoTime = false;
    }

    return p;
  }

  async loadCandidateData(examid: string, candidateno: string) {
     if(this.examid != examid || this.candidateno != candidateno){
      this.clearExamVideos();
    }
    this.examid = examid ?? '';
    this.candidateno = candidateno ?? '';
    if (this.examid && this.candidateno) {
      if (this.flagtime > 0) {
        const data: any = await this.recordingservice.getRecordingInfoAtTime(this.examid, this.candidateno, this.flagtime, false);

        this.targetvideotime = data.recordingtime;
        this.primaryViewVideoStartAt = data.startat - 30;
        if(this.primaryViewVideoStartAt < 0){
          this.primaryViewVideoStartAt = 0;
        }
        await this.loadExamVideo(this.targetvideotime, false, true, true, true);
        //this.router.navigate(['/examvideoplayer'], { queryParams: { examid: this.examid, candidateno: this.candidateno, time: data.recordingtime, delay: data.startat } });
        //return;


      }
      // if (!this.candidateNos || this.candidateNos.length == 0) {
      //   this.loadCandidates();
      // }
      await this.loadCandidateVideoList();

      // setTimeout(() => {
      //   document.getElementById('videos_grid_div')?.scrollTo(0, 100000000);//scroll to the bottom
      // })
      
    }
    
  }

  filled() {
    return !!this.examid;// && this.candidateno;
  }

  async loadCandidates() {
    const examid = this.examid;
    if (this.candidateno && this.displaySelectedCandidate) {
      this.candidateNos = [this.candidateno];
    } else {
      const candidates = await this.procteeService.getCandidates(examid);
      this.candidateNos = candidates.map(x => x.examNo);
    }
  }

  async loadCandidateVideoList() {
    const examid = this.examid;
    const candidateno = this.candidateno;

    this.procteeService.getCandidatePassportUrl(this.candidateno).then((url: string) => {
      this.passportPhotoUrl = url;
    });

    if (examid && candidateno) {
      try {
        this.loadingCandidateVideoList = true;
        this.primaryViewRecordings = [];
        this.secondViewRecordings = [];
        this.isCandidateSelected = true;
        const data = await this.recordingservice.getRecordings(examid, candidateno);
        const primaryViewTimes: any[] = data.primaryViewVideos[examid][candidateno];
        const secondViewTimes: any[] = data.secondViewVideos[examid][candidateno];

        for (const time of primaryViewTimes) {
          const url = this.recordingservice.getRecordingUrl(examid, candidateno, time, false);
          this.primaryViewRecordings.push({ candidateno: candidateno, time: time, url: url, datetimestring: new Date(parseInt(time)).toDateString() + ' ' + new Date(parseInt(time)).toLocaleTimeString() });
        }

        for (const time of secondViewTimes) {
          const url = this.recordingservice.getRecordingUrl(examid, candidateno, time, true);
          this.secondViewRecordings.push({ candidateno: candidateno, time: time, url: url, datetimestring: new Date(parseInt(time)).toDateString() + ' ' + new Date(parseInt(time)).toLocaleTimeString() });
        }
      }
      finally {
        this.loadingCandidateVideoList = false;
      }
    }
  }

  searchClicked() {
    this.loadCandidates();
    if (this.examid && this.candidateno) {
      this.loadCandidateVideoList();
    }
  }

  // openExamVideo(recording: any) {
  //   const url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/examvideoplayer'], {
  //       queryParams: {
  //         examid: this.examid,
  //         candidateno: recording.candidateno,
  //         time: recording.time
  //       }
  //     })
  //   );

  //   window.open(url, '_blank');
  // }

  async loadExamVideo(time: number, secondView: boolean, autoplay: boolean, initialLoad: boolean, synch: boolean): Promise<void> {
    console.trace('loading video: ', {time, secondView, autoplay, synch});
    return new Promise<void>(async (resolve, reject) => {
      try{
        if(initialLoad){
          this.loadingVideos = true;
        }

        if(!secondView){
          this.loadingPrimaryViewVideo = true;
          this.primaryViewVideoRecordingTime = Number(time);
        }
        else{
          this.loadingSecondViewVideo = true;
          this.secondaryViewVideoRecordingTime = Number(time);
        }

        let url = (await this.recordingservice.getRecordingPlayerUrl(this.examid, this.candidateno, time, secondView).toPromise()).url;
        
        //i had to make sure this gets converted to a number
        

        if(!secondView){
          this.primaryViewVideoUrl = url;
          const video: HTMLVideoElement = this.primaryViewVideo.nativeElement;
          let secondViewLoaderPromise: Promise<void> = Promise.resolve<void>(null);

          const __resolve = async () => {
            this.loadingPrimaryViewVideo = false;
            await secondViewLoaderPromise;
            console.trace('finished loading: ', {secondView});
            resolve();
            if(autoplay){
              video.play().catch((error) => {
                console.error(error);
              });//calling resolve first because video.play may be rejected in some cases
            }
          }

          const _canPlayHandler = async () => {
            video.removeEventListener('canplay', _canPlayHandler);
            const startAt = this.primaryViewVideoStartAt;
            this.primaryViewVideoStartAt = undefined;
            if(startAt){
              await this.seekVideoToTime(video, startAt);
            }
            await __resolve();
          }

          if(this.synchronizeVideos && synch){
            const secondViewRecordingInfoAtTime: any = await this.recordingservice.getRecordingInfoAtTime(this.examid, this.candidateno, time, true);
            if(secondViewRecordingInfoAtTime){
              this.secondViewVideoStartAt = (this.primaryViewVideoStartAt ?? 0) + secondViewRecordingInfoAtTime.startat;
              //this.synchronizingSecondViewVideo = true;
              try{
                //this.suspendSecondViewSyncCount++;
                secondViewLoaderPromise = this.loadExamVideo(secondViewRecordingInfoAtTime.recordingtime, true, autoplay, false, false);
              }
              finally{
                //this.synchronizingSecondViewVideo = false;
              }
            }
          }

          if(video.src != url){
            video.addEventListener('canplay', _canPlayHandler);
            video.src = url;
          }
          else{
            await this.seekVideoToTime(video, this.primaryViewVideoStartAt);
            this.primaryViewVideoStartAt = undefined;
            await __resolve();
          }
          //this.primaryViewVideo.nativeElement.src = url;
        }
        else{
          this.secondViewVideoUrl = url;
          const video: HTMLVideoElement = this.secondViewVideo.nativeElement;
          
          const __resolve = () => {
            this.loadingSecondViewVideo = false;
            console.trace('finished loading: ', {secondView});
            resolve();
            if(autoplay){
              video.play().catch((error) => {
                console.error(error);
              });//calling resolve first because video.play may be rejected in some cases
            }
          }

          const _canPlayHandler = async () => {
            video.removeEventListener('canplay', _canPlayHandler);
            const startAt = this.secondViewVideoStartAt;
            this.secondViewVideoStartAt = undefined;
            if(startAt){
              await this.seekVideoToTime(video, startAt);
            }
            __resolve();
          }

          if(video.src != url){
            video.addEventListener('canplay', _canPlayHandler);
            video.src = url;
            video.muted = this._synchronizeVideos;
          }
          else{
            await this.seekVideoToTime(video, this.secondViewVideoStartAt);
            this.secondViewVideoStartAt = undefined;
            __resolve();
          }
          //this.secondViewVideo.nativeElement.src = url;
        }
      }
      catch(error){
        reject(error);
        this.toastr.error(`${error.status} ${error.statusText}`);
        this.toastr.error(`${error.error}`);
      }
      finally{
        if(initialLoad){
          this.loadingVideos = false;
        }
      }
    });
    
  }

  clearExamVideos(){
    this.primaryViewVideoUrl = '';
    this.secondViewVideoUrl = '';
    //this.primaryViewVideo.nativeElement.src = '';
    //this.secondViewVideo.nativeElement.src = '';
  }

  async downloadVideo(time: number, secondView: boolean) {

    let url = (await this.recordingservice.getRecordingPlayerUrl(this.examid, this.candidateno, time, secondView).toPromise()).url;
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('href', url);
    downloadLink.setAttribute('target', '_blank');
    downloadLink.setAttribute('download', '');
    downloadLink.click();
  }
}
